<template>
  <section class="">
    <table class="unstriped boss-table-4 pega-th-color-important">
      <thead>
        <tr>
          <th>
            アプローチした求人
            <span
              v-if="approachedSummaries.length && !isPrintPreview"
              v-tooltip="{ content: '応募期限内のものは濃色で表示、応募期限外のものは薄色で表示されます。'}"
              data-test="approached"
              class="pega-circle"
            >?</span>
          </th>
          <th>いいね</th>
          <th>オファーDM</th>
          <th>スカウト</th>
          <th>スカウト特典</th>
        </tr>
      </thead>
      <tbody v-if="approachedSummaries.length">
        <tr
          v-for="(approachedSummary, i) in approachedSummaries"
          :key="i"
        >
          <td
            :data-test="'management-name-' + i"
            class="boss-table-data"
          >
            求人ID: {{ approachedSummary.job.id }} {{ approachedSummary.job.name }}
          </td>
          <td class="boss-center">
            <span
              v-if="approachedSummary.liked.isSend"
              :class="{ 'pega-gray-color-important': !approachedSummary.liked.isEffective }"
              :data-test="'liked-ellipse-' + i"
            >●
            </span>
          </td>
          <td class="boss-center">
            <span
              v-if="approachedSummary.offerDm.isSend"
              :class="{ 'pega-gray-color-important': !approachedSummary.offerDm.isEffective }"
              :data-test="'offer-dm-ellipse-' + i"
            >●
            </span>
          </td>
          <td class="boss-center">
            <span
              v-if="approachedSummary.scout.isSend"
              :class="{ 'pega-gray-color-important': !approachedSummary.scout.isEffective }"
              :data-test="'scout-ellipse-' + i"
            >●
            </span>
          </td>
          <td>
            <span
              v-for="(specialFavor, j) in approachedSummary.specialFavors"
              :key="j"
              v-tooltip="{ content: specialFavorBy(specialFavor.id).description}"
              :data-test="'special-favor-' + i + '-' + j"
              :class="{ 'boss-bonus-end': !specialFavor.isEffective }"
              class="boss-bonus-check-text boss-check-true pega-bonus-check-important"
            >{{ specialFavor.name }}</span>
          </td>
        </tr>
      </tbody>
      <tbody
        v-else
        data-test="no-approached"
      >
        <tr>
          <td>アプローチした求人はありません。</td>
          <td /><td /><td /><td />
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    approachedSummaries: {
      type: Array,
      required: true
    },
    isPrintPreview: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      specialFavorBy: 'specialFavorBy'
    })
  }
}
</script>
